import React from 'react';

import CHorizontalScrollContainer from './components/CHorizontalScrollContainer';
import CPageModule from './components/CPageModule';
import { type TPandasDataFrameDict } from './components/TPandasDataFrameDict';
import { EStylings } from './enums/EStylings';
import { useAppSelector } from './hooks/hooks';
import { type IRequestState } from './models/IRequestState';

export interface IPageModuleTableBaseProps {
  data: TPandasDataFrameDict | undefined;
  state: IRequestState | undefined;
  table: React.ReactNode;
  pagination: React.ReactNode | undefined;
  timestamp: React.ReactNode | undefined;
  searchBar: React.ReactNode | undefined;
  style?: Pick<React.CSSProperties, 'width' | 'maxWidth'>;
}

export default function CPageModuleTableBase(props: IPageModuleTableBaseProps) {
  const { dashboardOutletDimensions } = useAppSelector((state) => state.dashboard);
  const numericWidthStyle = Number.isNaN(Number.parseInt(String(props.style?.width)))
    ? EStylings.MIN_CONTENT_WIDTH
    : Number.parseInt(String(props.style?.width));
  const numericMaxWidthStyle: 'auto' | number = Number.isNaN(Number.parseInt(String(props.style?.maxWidth)))
    ? 'auto'
    : Number.parseInt(String(props.style?.maxWidth));
  const renderFullWidth =
    (props.style?.width ?? props.style?.maxWidth) &&
    dashboardOutletDimensions.w >
      2 * EStylings.PAGE_MODULE_PAD + Math.max(numericWidthStyle, EStylings.MIN_CONTENT_WIDTH);

  const timestampObj = () => <div className={'text-right text-xs -mt-2 w-full'}>{props.timestamp}</div>;

  return (
    <CPageModule fullWidth>
      {props.searchBar && (
        <CPageModule submodule style={{ paddingTop: 0, paddingBottom: 0 }}>
          {props.searchBar}
        </CPageModule>
      )}
      <CPageModule fullWidth submodule apiRequestState={props.state} showContent={!!props.data}>
        {renderFullWidth ? (
          <CPageModule submodule style={{ paddingTop: 0, paddingBottom: 0, maxWidth: numericMaxWidthStyle }}>
            {props.table}
            {timestampObj()}
          </CPageModule>
        ) : (
          <>
            <CHorizontalScrollContainer>
              <div
                style={{
                  width: props.style?.width ?? EStylings.MIN_CONTENT_WIDTH
                }}
              >
                {props.table}
              </div>
            </CHorizontalScrollContainer>
            <CPageModule submodule style={{ paddingTop: 0, paddingBottom: 0 }}>
              {timestampObj()}
            </CPageModule>
          </>
        )}
      </CPageModule>
      <CPageModule submodule style={{ paddingTop: 0, paddingBottom: 0 }}>
        {props.pagination}
      </CPageModule>
    </CPageModule>
  );
}
